<div class="card border-danger">
    <div class="card-header text-danger">
        <h1>Portail Fournisseur</h1>
    </div>
    <DIV class="card-body my-4 mx-2" *ngIf="!sharedSvc.loggedExtUser">
        <H3>Bienvenue sur le portail fournisseur ENDEL</H3>
        <P>Veuillez vous connecter pour accéder à votre tableau de bord.</P>
        <a class="btn btn-primary" role="button" [routerLink]="['/suppliers']">Se connecter</a>
    </DIV>

    <DIV class="card-body my-4 mx-2" *ngIf="sharedSvc.loggedExtUser">
        <H3>Bienvenue {{sharedSvc.loggedExtUser.Contact?.Firstname}} {{sharedSvc.loggedExtUser.Contact?.Lastname}}</H3>
        <P>Utilisez le bouton ci-dessous pour accéder à votre tableau de bord.</P>
        <a class="btn btn-primary" role="button" [routerLink]="['/suppliers']">Aller au tableau de bord</a>
    </DIV>
</div>